var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMiniCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#0190D8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.4868,
    height: 5.4359,
    rx: 2.7179,
    transform: "scale(.9972 1.0028) rotate(45 2.5042 3.695)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 43.4868,
    height: 5.4359,
    rx: 2.7179,
    transform: "scale(.9972 1.0028) rotate(-45 35.4132 16.0868)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h33v33H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniCrossIcon);
export default __webpack_public_path__ + "static/media/mini-cross-icon.ecee10161763a79ebcdb0d55791e95f2.svg";
export { ForwardRef as ReactComponent };